import {Component, OnInit} from '@angular/core';
import {LoginService} from "../../services/login.service";
import {MatProgressBarModule} from "@angular/material/progress-bar";

@Component({
  selector: 'app-end-session',
  standalone: true,
  templateUrl: './end-session.component.html',
  imports: [
    MatProgressBarModule
  ],
  styleUrls: ['./end-session.component.scss']
})

export class EndSessionComponent implements OnInit {
  constructor(private loginService: LoginService) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.loginService.logout()
    }, 3000)
    ;
  }
}
